import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { theme } from 'utils/style/theme';
import useCurrencyDropQuery from 'hooks/queries/common/useCurrencyDropQuery';
import { ICoinStoreProps, ISalesLangProps } from 'utils/types/saleTypes';
import { PublicState } from 'utils/constant';
import { coinStoreApi } from 'apis/sales/coinStoreApis';
import { useThumbnailDropList } from 'hooks/queries/sale/coinStoreQuery';
import useLocalizingDropList from 'hooks/queries/common/useLocalizingDropList';
import fetchLocalizingInput from 'hooks/fetchLocalizingInput';
import UtcTimer from 'components/etc/UtcTimer';
import CheckboxOneType from 'components/input/CheckboxOneType';
import DefaultInput from 'components/input/DefaultInput';
import DefaultRadio from 'components/input/DefaultRadio';
import RangeDatePicker from 'components/input/RangeDatePicker';
import DefaultSelect from 'components/select/DefaultSelect';
import DefaultLayout from 'components/layout/DefaultLayout';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import InputFlexBox from 'components/container/InputFlexBox';
import InputWrappingBox from 'components/container/InputWrappingBox';
import TextFlexBox from 'components/container/TextFlexBox';
import ImageSelect from 'components/select/ImageSelect';
import CurrentImgTag from 'components/etc/CurrentImgTag';
import CoinStoreLocalizingInputForm from './CoinStoreLocalizingInputForm';
import DefaultButton from 'components/button/DefaultButton';
/**
 * * 판매 - 코인상점 관리 등록 & 수정 페이지
 */

interface ISetProps {
  currency: string;
}
const CoinStoreInputPage = () => {
  const publicState = PublicState();
  const navigate = useNavigate();
  const { coinId } = useParams();
  const [cookies] = useCookies();

  const authUpdate = JSON.parse(cookies?.managementAuth);
  const dateFormat = 'YYYY-MM-DD HH:mm:00';
  const today = dayjs().format(dateFormat);
  const [langList, setLangList] = useState<ISalesLangProps[]>();
  const [detailData, setDetailData] = useState<ICoinStoreProps>(); //상세정보
  const [productSetCheck, setProductSetCheck] = useState<boolean>(false); // 세트 상품 체크 유무
  const [productSetData, setProductSetData] = useState<ISetProps[]>([]); // 세트 상품 [{coin_product_id:0, currency:''}]
  const { data: localizingData } = useLocalizingDropList(); // 다국어
  const { data: currencyDropData } = useCurrencyDropQuery(''); // 재화 드롭 리스트
  const { data: thumbnailDropList } = useThumbnailDropList(); // 썸네일 드롭 리스트

  /// 로컬라이징 - 텍스트 인풋
  const handleLocalInputChange = (e) => {
    const { value, name, id } = e.target;

    setLangList(
      langList?.map((v) => (v.lang === id ? { ...v, [name]: value } : v)),
    );
  };

  /// 멀티 드롭다운 이벤트 (상품 종류)
  const handleMultiChange = async (val: any, option: any) => {
    // console.log(val);
    // console.log(val.toString());
    // console.log(option);

    // setList [{currency: ''}] 형식으로 담기. 세트 상품인데 우선 보류라고 한다. (22.6.30.지연)
    const newData: ISetProps[] = [];
    val.map((v) => newData.push({ currency: v }));
    setProductSetData(newData);

    // 썸네일 이미지 미리보기
    const resThumb = await coinStoreApi.coinCurrencyThumb(val.toString());

    if (!resThumb) {
      return false;
    }
    if (resThumb.length > 0) {
      setDetailData({
        ...detailData!,
        [option[0].name]: val.toString(),
        thumbnail_url: resThumb[0].thumbnail_id_url,
        thumbnail_id: resThumb[0].thumbnail_id,
        thumbnail_key: resThumb[0].thumbnail_id_key,
      });
    } else {
      setDetailData({ ...detailData!, [option[0].name]: val.toString() });
    }

    // 상품 종류가 2개 이상이면 세트 상품에 체크 되게 한다.
    if (val.length <= 1) {
      setProductSetCheck(false);
    } else {
      setProductSetCheck(true);
    }
  };

  ///  인풋, 라디오 이벤트
  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === 'is_common') {
      setDetailData({ ...detailData!, [name]: checked ? 1 : 0 });
    } else {
      setDetailData({ ...detailData!, [name]: value });
    }
  };

  /// 이미지 드롭다운
  const handleSelectChange = (val, option) => {
    setDetailData({ ...detailData!, [option.name]: val });
  };

  /// 무제한 체크
  const handleUnlimitedChecked = (e) => {
    e.target.checked === true
      ? setDetailData({
          ...detailData!,
          end_date: '9999-12-31 00:00:00',
        })
      : setDetailData({ ...detailData!, end_date: `${today}` });
  };

  /// 날짜 조절
  const handleDateChange = (dates, dateStrings) => {
    // console.log(dates);
    if (!dates) {
      setDetailData({
        ...detailData!,
        start_date: `${today}`,
        end_date: `${today}`,
      });
      return;
    }
    setDetailData({
      ...detailData!,
      start_date: `${dateStrings[0]}`,
      end_date: `${dateStrings[1]}`,
    });
  };

  const handleSubmit = async () => {
    ('');
  };

  /// 상세 정보 불러오기
  const fetchDetailData = async () => {
    const res = await coinStoreApi.detail(coinId);
    console.log(res);

    // 다국어 데이터 재가공 함수로 보내주자
    fetchLocalizingInput(res?.lang, setLangList);
    setDetailData(res.detail[0]);
    setProductSetData(res.set);
    if (res.set?.length > 0) {
      setProductSetCheck(true);
    }

    // // 코인상점 디테일
    // // 상품 종류. 다중 셀렉 박스로 사용하기 위해 배열로 재가공
    // const currencyArr = res?.detail[0]?.currency?.split(',');

    // //재화url이 없을때, 한 번 더 재화관리에 들어가서 해당id url갱신해준다.

    // console.log(res?.detail[0].currency, '<currency');
    // const urlRes = await currnecyApi.currencyDetailList(
    //   res?.detail[0].currency,
    // );
    // console.log(urlRes);

    // setDetailData({
    //   ...res?.detail[0],
    //   currency: currencyArr,
    //   thumbnail_id: urlRes.detail[0].icon_image_id,
    //   thumbnail_url: urlRes.detail[0].icon_image_url,
    // });
  };

  /// 등록일 때 초기 데이터, 다국어 세팅하기
  const isRegisterLangProcessing = () => {
    const newArr: any = [];
    localizingData?.map((v, i) => {
      newArr.push({
        code: v.value,
        code_name: v.text,
        currencyName: '',
        key: i,
      });
    });
    setLangList(newArr);
    // setDetailData({
    //   action: 'I',
    //   connected_project: Number(projectId),
    //   currency: '',
    //   currency_type: 'gift',
    //   is_sellable: 0,
    //   is_public: 0,
    //   model_id: -1,
    //   local_code: -1,
    //   icon_image_id: -1,
    //   resource_image_id: -1,
    //   dev_name: '',
    //   price: 0,
    //   sale_price: 0,
    // });

    // setAbilityData([{ key: 0, ability_id: -1, add_value: 0, speaker: '' }]);
  };

  /// 목록 보기
  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (coinId === '0') {
    } else {
      fetchDetailData().catch(console.log);
    }
  }, []);
  return (
    <DefaultLayout>
      <SubmitFlexBox>
        <>
          <DefaultButton
            style={{ marginRight: '1rem' }}
            onClick={handleGoBack}
            typename='sub'
          >
            목록보기
          </DefaultButton>
          <DefaultButton onClick={handleSubmit}>저장하기</DefaultButton>
        </>
      </SubmitFlexBox>
      <InputFlexBox style={{ marginTop: '3rem' }}>
        <InputWrappingBox left>
          <CoinStoreLocalizingInputForm
            title='상품명'
            langList={langList}
            onChange={handleLocalInputChange}
          />
        </InputWrappingBox>
        <InputWrappingBox>
          <TextFlexBox>
            <DefaultSelect
              title='상품 종류'
              name='currency'
              value={
                detailData?.currency === ''
                  ? undefined
                  : detailData?.currency?.split(',')?.map((v) => {
                      return v;
                    })
              }
              optionList={currencyDropData}
              onChange={handleMultiChange}
              mode='multiple'
              allowClear
              showSearch
              style={{ width: '30rem', marginRight: '1rem' }}
            />
            <TextFlexBox style={{ marginRight: '1rem' }}>
              <CheckboxOneType
                // name="isSet"
                checked={productSetCheck}
                // defaultChecked={productSetData?.length > 0 ? true : false}
                disabled
              />
              <h5 style={{ color: `${theme.colors.gray_3}` }}>세트 상품</h5>
            </TextFlexBox>
            <TextFlexBox>
              <CheckboxOneType
                name='is_common'
                onChange={handleInputChange}
                checked={detailData?.is_common === 1 ? true : false}
              />
              <h5>공용 작품</h5>
            </TextFlexBox>
          </TextFlexBox>
          <TextFlexBox>
            <div>
              <RangeDatePicker
                title='판매 기간'
                style={{
                  marginBottom: '0.15rem',
                  marginRight: '0.5rem',
                }}
                showTime={true}
                value={[
                  dayjs(detailData?.start_date, dateFormat),
                  dayjs(detailData?.end_date, dateFormat),
                ]}
                ranges={{
                  오늘: [dayjs(), dayjs()],
                  이번주: [
                    dayjs().startOf(today as any),
                    dayjs().endOf('week'),
                  ],
                  이번달: [
                    dayjs().startOf(today as any),
                    dayjs().endOf('month'),
                  ],
                }}
                onChange={handleDateChange}
                format={dateFormat}
              />
              <UtcTimer
                onGrayBox={true}
                startDate={detailData?.start_date}
                endDate={detailData?.end_date}
                style={{
                  marginBottom: theme.margins.bottomInModal,
                }}
              />
            </div>
            <TextFlexBox style={{ marginBottom: theme.margins.bottomInPage }}>
              <CheckboxOneType
                name='unlimited'
                onChange={handleUnlimitedChecked}
                checked={
                  detailData?.end_date === '9999-12-31 00:00:00' ? true : false
                }
              />
              <h5>무제한</h5>
            </TextFlexBox>
          </TextFlexBox>
          <DefaultInput
            title='판매 가격'
            name='price'
            value={detailData?.price}
            onChange={handleInputChange}
            type='number'
          />
          <DefaultInput
            title='할인 가격'
            name='sale_price'
            value={detailData?.sale_price}
            onChange={handleInputChange}
            type='number'
          />
          <DefaultRadio
            title='공개 여부'
            name='is_public'
            optionList={publicState}
            defaultValue={detailData?.is_public}
            onChange={handleInputChange}
            style={{ marginBottom: '1rem' }}
          />
          <TextFlexBox>
            <>
              {detailData?.thumbnail_url !== '' && (
                <CurrentImgTag src={detailData?.thumbnail_url} />
              )}
            </>
            <ImageSelect
              labelTitle='썸네일'
              name='thumbnail_id'
              value={detailData?.thumbnail_id}
              optionList={thumbnailDropList}
              onChange={handleSelectChange}
              style={{ marginLeft: '1rem' }}
            />
          </TextFlexBox>
        </InputWrappingBox>
      </InputFlexBox>
    </DefaultLayout>
  );
};

export default CoinStoreInputPage;
